import { SITE_URL } from "@/lib/site-data";

export const LOGO_URL = `${SITE_URL}/og-image.jpg`;

export const breadcrumbLd = (name: string, path: string) => ({
  type: "application/ld+json",
  children: JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
      { "@type": "ListItem", position: 2, name, item: `${SITE_URL}${path}` },
    ],
  }),
});

export const webPageLd = (type: string, name: string, description: string, path: string) => ({
  type: "application/ld+json",
  children: JSON.stringify({
    "@context": "https://schema.org",
    "@type": type,
    name,
    description,
    url: `${SITE_URL}${path}`,
    publisher: { "@type": "Organization", name: "JTB Floors", logo: LOGO_URL, url: `${SITE_URL}/` },
  }),
});
